import { createFileRoute } from '@tanstack/react-router'

import { EditRecurringInvoicePage } from '@/pages/invoices/recurring-invoices/[id]/edit/EditRecurringInvoicePage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/invoices/recurring-invoices/$id/edit/',
)({
  component: EditRecurringInvoicePage,
})
